
<template>
  <div v-if="Object.keys(dados).length"
       class="content--sinoreg EditarObito">
    <header-blue>
      <h4 class="resumo-show_title pl-2">
        <b-row>
          <b-col sm="2"
                 class="resumeTitle">
            <svg class="obito-show_icon icon--md typeIcon"
                 role="presentation">
              <use :xlink:href="'#' + icon_obito.id" />
            </svg>
            Óbito {{ dados.registro.flag_cancelado ? "CANCELADO" : '' }}
          </b-col>

          <b-col sm="10"
                 class="headerEditObito">
            <b-row>
              <span class="pt-3 resumo-show_title-label">
                {{ dados.pessoa && dados.pessoa.nome || null }}
              </span>
            </b-row>
            <b-row>
              <HeaderBoxResume v-if="dados.registro.registro_id"
                               class="matricula_id"
                               :info="dados.pessoa.cpf | cpf"
                               text="CPF" />
              <HeaderBoxResume v-if="dados.registro.registro_id"
                               :info="dados.registro.data_ocorrido | date"
                               text="Data do ocorrido" />
              <HeaderBoxResume v-if="dados.registro.registro_id"
                               :info="dados.registro.data_registro | date"
                               text="Data de registro" />
              <HeaderBoxResume v-if="dados.registro.registro_id"
                               class="matricula_id"
                               :info="dados.registro.matricula | maskMatricula"
                               text="Matrícula" />
            </b-row>
          </b-col>
        </b-row>
      </h4>
    </header-blue>
    <b-tabs content-class=""
            class="EditarObito-border"
            lign="left"
            :active-nav-item-class="errosAbas.indexOf(tab_atual + 1) != -1 ? 'EditarObito--tab-active_error': 'EditarObito--tab-active'">
      <b-tab :active="tab_atual==0"
             @click="tab_atual=0">
        <template v-slot:title>
          <div :class="{'nav-link_error':errosAbas.indexOf(1) != -1 && tab_atual != 0}">
            Falecido
            <IconSvg v-if="errosAbas.indexOf(1) != -1 "
                     class="icon-error"
                     icon="alert" />
          </div>
        </template>
        <PassoFalecido class="py-2"
                       :data="dados"
                       :read-only="true"
                       :prop-cartorio="dadosCartorio"
                       :prop-correcoes="correcoes"
                       @updatedPessoa="updatedPessoa($event)"
                       @genitorRemoved="removeGenitor"
                       @anteriorRemoved="removeAnterior"
                       @deleteAddress="deleteAddress"
                       @removeDocumento="removeDocumento"
                       @deleteError="deleteError" />
      </b-tab>
      <b-tab :active="tab_atual==1"
             @click="tab_atual=1">
        <template v-slot:title>
          <div :class="{'nav-link_error':errosAbas.indexOf(2) != -1 && tab_atual != 1}">
            Dados do Falecimento
            <IconSvg v-if="errosAbas.indexOf(2) != -1 "
                     class="icon-error"
                     icon="alert" />
          </div>
        </template>

        <PassoDadosFalecimento class="py-2"
                               :data="dados"
                               :read-only="true"
                               :prop-cartorio="dadosCartorio"
                               :prop-correcoes="correcoes"
                               @changed="update"
                               @medicoRemoved="removeMedico"
                               @deleteError="deleteError" />
      </b-tab>
      <b-tab :active="tab_atual==2"
             @click="tab_atual=2">
        <template v-slot:title>
          <div :class="{'nav-link_error':errosAbas.indexOf(3) != -1 && tab_atual != 2 }">
            Outras informações
            <IconSvg v-if="errosAbas.indexOf(3) != -1"
                     class="icon-error"
                     icon="alert" />
          </div>
        </template>

        <PassoOutrasInfo class="py-2"
                         :read-only="true"
                         :data="dados"
                         :prop-cartorio="dadosCartorio"
                         :prop-correcoes="correcoes"
                         @deleteError="deleteError"
                         @changed="update"
                         @documentoRemoved="removeDocumento"
                         @filhoDeixadoRemoved="removeFilhoDeixado"
                         @parteRemoved="removeParte"
                         @deleteAddress="deleteAddress"
                         @verifyParte="verifyParte" />
      </b-tab>

      <b-tab :active="tab_atual==3"
             @click="tab_atual=3">
        <template v-slot:title>
          <div :class="{'nav-link_error':errosAbas.indexOf(4) != -1 && tab_atual != 3}">
            Registro
            <IconSvg v-if="errosAbas.indexOf(4) != -1"
                     class="icon-error"
                     icon="alert" />
          </div>
        </template>

        <PassoEditarRegistro class="py-2"
                             :data="dados"
                             :prop-correcoes="correcoes"
                             @deleteError="deleteError"
                             @changed="update" />
      </b-tab>
      <b-tab v-if="dados.registro.transporte"
             :active="tab_atual==4"
             @click="tab_atual=4">
        <template v-slot:title>
          <div :class="{'nav-link_error':errosAbas.indexOf(5) != -1 && tab_atual != 4}">
            Transporte
            <IconSvg v-if="errosAbas.indexOf(5) != -1"
                     class="icon-error"
                     icon="alert" />
          </div>
        </template>

        <AbaTransporte class="py-2"
                       :data="dados"
                       :prop-correcoes="correcoes"
                       @changed="update" />
      </b-tab>
    </b-tabs>

    <div class="cadastroObito_footer mb-2 border-top border-primary pt-3">
      <div class="row no-gutters justify-content-between">
        <ExcluirCancelarRegistro v-if="dados.registro && dados.registro.registro_id"
                                 :prop-registro="dados.registro"
                                 :registro-id="dados.registro.registro_id"
                                 @onBlockUpdate="status => bloquearRegistro(status)" />

        <div class=" justify-content-end">
          <div class="d-inline-block">
            <b-link id="btn-submit-cancel"
                    class="btn btn-sm btn-dark"
                    @click="voltar">
              Voltar
            </b-link>
          </div>
          <div v-if="dados.registro.existe_crc"
               class="d-inline-block ml-2">
            <button id="btn-submit-registro"
                    v-b-modal.modalMotivoAlteracao
                    class="btn btn-sm btn-primary"
                    type="button"
                    :disabled="enabledSave">
              Salvar
            </button>
          </div>
          <div v-else
               class="d-inline-block ml-2">
            <button id="btn-submit-registro"
                    class="btn btn-sm btn-primary"
                    type="button"
                    :disabled="enabledSave"
                    @click="verifyInputs">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>

    <MotivoAlteracao tipo="O"
                     :tarefa-alteracao-carga="tarefaAlteracaoCarga"
                     @gravarAtualizacao="verifyErrors($event)" />
  </div>
</template>

<script>
  /* components */
  import HeaderBlue from "@/components/SofiaRei/Headers/HeaderBlue"
  import HeaderBoxResume from "@/components/SofiaRei/Busca/HeaderBoxResume"
  import PassoFalecido from '@/components/SofiaRei/Obito/Passos/PassoFalecido.vue'
  import PassoDadosFalecimento from '@/components/SofiaRei/Obito/Passos/PassoDadosFalecimento.vue'
  import PassoOutrasInfo from '@/components/SofiaRei/Obito/Passos/PassoOutrasInfo.vue'
  import PassoEditarRegistro from '@/components/SofiaRei/Obito/Passos/PassoEditarRegistro.vue'
  import MotivoAlteracao from '@/components/SofiaRei/Resumo/MotivoAlteracao.vue'
  import ExcluirCancelarRegistro from '@/components/SofiaRei/ExcluirCancelarRegistro'
  import AbaTransporte from "@/components/SofiaRei/AbaTransporte.vue"

  /* services */
  import CartorioService from "@/services/CartorioService"
  import ObitoService from "@/services/Registros/Obito"

  /* assets */
  import icon_obito from "@/assets/icons/flower.svg?sprite"

  /* outros */
  import { mapGetters } from 'vuex'
  import Swal from "sweetalert2"

  export default {
    name: "EditarObito",
    components: {
      HeaderBlue,
      HeaderBoxResume,
      PassoFalecido,
      PassoDadosFalecimento,
      PassoOutrasInfo,
      PassoEditarRegistro,
      ExcluirCancelarRegistro,
      MotivoAlteracao,
      AbaTransporte
    },
    props: {
      propCorrecoes: {type: Object, default: () => ({})},
      propObito: {
        type: Object,
        default: () => ({})
      }
    },
    provide: function () {
      return {
        $validator: this.$validator
      }
    },
    data () {
      return {
        icon_obito,
        tipo: '',
        tab_atual: 0,
        obito_updated: {},
        deleteds: { genitores: [], anteriores: [], medicos: [], partes: [], pessoaDocumentos: [], filhoDeixado: [], enderecos: []  },
        dados: {
          genitores: [], medicos: [], documentos: [], filhoDeixado: [],
          registro: { anteriores: [], testemunhas: [], declarantes: [], partes: [] },
          natimorto: ''
        },
        dadosCartorio: {},
        parte: {},
        correcoes: {...this.propCorrecoes},
        errosAbas: [],
        registro_id: null,
        tarefaAlteracaoCarga: null
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        cartorio: 'auth/getCartorioObj'
      }),

      enabledSave () {
        const obj = { ...this.obito_updated }
        let disableIt = false
        if ((!obj.nome || !obj.pessoa.nome) || (!obj.pessoa.cpf && !obj.pessoa.cpf_sem_inscricao)) { disableIt = true }

        return disableIt
      },
    },
    watch: {
      propCorrecoes () {
        this.correcoes = {...this.propCorrecoes}
      }
    },
    async beforeMount () {
      let dados = {}

      loader({ text: 'Carregando dados...', active: true })

      try {
        const obito = Object.values(this.propObito).length ? this.propObito : await ObitoService.getObitoById(this.$route.params.id)

        this.dados.natimorto = (obito.registro.tipo_registro == 'NT') ? true : false


        this.registro_id = obito.registro_id

        this.tarefaAlteracaoCarga = obito.registro.tarefas.find((tarefa) => {
          return tarefa.acao === 'ALTERACAO' && tarefa.tipo === 'CARGA'
        })

        // TODO: rever necessidade desse método
        await ObitoService.carregarObito(this.$route.params.id, this.$store.state.auth.cartorio_id, this.registro_id, obito).then(res => {
          dados = {
            ...res.dados,
            pessoa_desconhecida: res.dados.pessoa_desconhecida === 1 ? true : false,
            natimorto: res.dados.natimorto === 1 ? true : false,
            deixa_testamento: (res.dados.deixa_testamento === 1),
            eleitor_ativo: (res.dados.eleitor_ativo === 1),
            reservista: (res.dados.reservista === 1)
          }

          loader({ text: '', active: false })
        })
      } catch (e) {

        if (!this.dados) {
          this.$router.push('/pagina-nao-encontrada')
        }

        loader({ text: '', active: false })
      }

      this.dados = dados
      this.obito_updated = dados
      loader({ text: '', active: false })
    },

    mounted () {
      this.getCartorio()
      this.verifyCorrecoes().abas()
      this.controlEvent().addEvent()
    },

    methods: {
      voltar () {
        this.$router.push({ name: 'resumo_obito', params: { id: this.$route.params.id }})
      },
      update (updated) {
        this.obito_updated = updated
      },
      updatedPessoa ($event) {
        const data = $event

        this.obito_updated.pessoa.cpf = data.cpf
        this.obito_updated.pessoa.cpf_sem_inscricao = data.cpf_sem_inscricao,
        this.obito_updated.cpf_sem_inscricao = data.cpf_sem_inscricao,
        this.obito_updated.pessoa.nome = data.nome
        this.obito_updated.pessoa.data_nascimento = data.data_nascimento
        this.obito_updated.pessoa.sexo = data.sexo
        this.obito_updated.pessoa.cor_pele = data.cor_pele
        this.obito_updated.pessoa.nacionalidade = data.nacionalidade
        this.obito_updated.pessoa.nacionalidade_codigo = data.nacionalidade_codigo
        this.obito_updated.nacionalidade_codigo = data.nacionalidade_codigo
        this.obito_updated.pessoa.estado_civil = data.estado_civil
        this.obito_updated.pessoa.ocupacao_codigo = data.ocupacao_codigo
        this.obito_updated.pessoa.ocupacao_declarada = data.ocupacao_declarada
        this.obito_updated.pessoa.naturalidade = data.naturalidade
        this.obito_updated.pessoa.naturalidade_declarada = data.naturalidade_declarada
        this.obito_updated.pessoa.uf = data.uf
        this.obito_updated.pessoa.endereco = data.endereco
        this.obito_updated.pessoa.ultimo_convivente = data.ultimo_convivente

        this.obito_updated.nome = data.nome
        this.obito_updated.idade = data.idade
        this.obito_updated.pessoa_desconhecida = data.pessoa_desconhecida
        this.obito_updated.natimorto = data.natimorto
        this.obito_updated.idade_tipo = data.idade_tipo
      },
      removeMedico (medico) {
        this.deleteds.medicos.push(medico.medico_id)
      },
      removeAnterior (anterior) {
        this.deleteds.anteriores.push(anterior.registro_anterior_id)
      },
      removeGenitor (genitor) {
        this.deleteds.genitores.push(genitor.genitor_id)
      },
      removeDocumento (documento) {
        if (documento.pessoa_documento_id) {
          this.deleteds.pessoaDocumentos.push(documento.pessoa_documento_id)
        }
      },
      removeFilhoDeixado (filho) {
        this.deleteds.filhoDeixado.push(filho.filho_deixado_id)
      },
      removeParte (parte) {
        this.deleteds.partes.push(parte.parte_id)
      },
      //Verificando campos obrigatorios
      verifyInputs ($event = null) {
        this.$validator.validate().then(resp => {
          const {errors: {items}} = this.$validator
          const messages = []

          items.forEach(item => {
            switch (item.field) {
            case 'nome':
              messages.push('Informe o nome do registrado')
              break
            case 'data_nascimento':
              messages.push('Data de nascimento inválida')
              break
            case 'data_ocorrido':
              item.msg == "Campo obrigatório" ? messages.push('Informe a data do ocorrido') : messages.push('Data do ocorrido inválida')
              break
            case 'hora_ocorrido':
              messages.push('Hora do ocorrido inválida')
              break
            case 'numero_declaracao_obito':
              messages.push('Nº Declaração óbito inválido')
              break
            case 'data_registro':
              item.msg == "Campo obrigatório" ? messages.push('Informe a data do registro') : messages.push('Data do registro inválida')
              break
            case 'registro_livro':
              messages.push('Informe o número do livro')
              break
            case 'registro_folha':
              messages.push('Informe o número da folha')
              break
            case 'registro_termo':
              messages.push('Informe o número do registro')
              break
            }
          })

          if (resp && !items.length && !this.enabledSave) {
            const {pessoa, tipo} = this.parte

            if (pessoa && pessoa.nome && tipo === 'DECLARANTE') {
              this.dados.registro.partes.push(this.parte)
              this.parte = {}
            }
            //window.scrollTo({top: 0, behavior: 'smooth'})
            return this.save($event)
          } else {
            let invalids = document.querySelectorAll('.is-invalid')
            this.invalids(invalids)
            !!messages ? this.showErrorList(messages) : ''
          }
        })
      },

      async save ($event = null) {

        const data = $event

        try {
          loader({ text: "Atualizando registro...", active: true })

          this.obito_updated.deleteds = this.deleteds
          // Motivos registro
          this.obito_updated.registro.cod_motivo_alt = this.motivo_alteracao
          this.obito_updated.registro.data_averb_motivo_alt = this.motivo_alteracao_data

          const {pessoa, tipo} = this.parte

          if (pessoa && pessoa.nome && tipo === 'DECLARANTE') {
            this.dados.registro.partes.push(this.parte)
            this.parte = {}
          }

          await this.setInclusoes()

          if (data) {
            this.obito_updated.registro.cod_motivo_alt = data.codigo
            this.obito_updated.registro.data_averb_motivo_alt = data.dataAverb
          }

          if (this.obito_updated.numero_declaracao_obito) {
            this.obito_updated.numero_declaracao_obito = this.obito_updated.numero_declaracao_obito.replace('-', '').replace('-', '')
          } else {
            this.obito_updated.numero_declaracao_obito = null
          }

          if (!this.obito_updated.sem_declaracao_obito) this.obito_updated.sem_declaracao_obito = false

          if (!this.obito_updated.registro.oficial) {
            this.obito_updated.registro.oficial = this.cartorio.nome_oficial
          }

          await ObitoService.editarObito(this.obito_updated)

          objSwal.success.title = "Registro Atualizado com Sucesso!"
          objSwal.success.text = ''

          return Swal.fire(objSwal.success).then(() => this.voltar())
        } catch (error) {
          if (Array.isArray(error.response && error.response.data)) {
            const messages = []

            error.response.data.forEach(resp => {
              switch (resp.message) {
              case 'unique validation failed on numero_declaracao_obito':
                messages.push(`A D.O ${this.obito_updated.numero_declaracao_obito} já está vinculada à outro registro`)
                break
              case 'sofia validation failed on numero_declaracao_obito':
                messages.push(`D.O Número ${this.obito_updated.numero_declaracao_obito} não é válida.`)
                break
              }
            })

            this.showErrorList(messages)

          } else {
            if (error.response && error.response.data.message && !error.response.data.message.message) {
              return this.displayError('TEXT', error.response.data.message)
            } else {
              return this.displayError('TEXT', 'Houve algum erro ao editar o registro de óbito, favor contactar o suporte.')
            }
          }
        }
        finally {
          loader({text: "", active: false})
        }

      },
      setInclusoes () {
        // Inclusão de Documentos
        if (this.obito_updated.pessoa && this.obito_updated.pessoa.documentos) {
          this.obito_updated.pessoa.documentos.map(doc => {
            doc.pessoa_id = this.obito_updated.pessoa.pessoa_id
          })
        }

        // Inclusão de Filhos
        if (this.obito_updated.filhoDeixado) {
          this.obito_updated.filhoDeixado.map(filho => {
            filho.obito_id = this.obito_updated.obito_id
          })
        }

        // Innclusão de Médicos
        if (this.obito_updated.medicos) {
          this.obito_updated.medicos.map(medico => {
            medico.obito_id = this.obito_updated.obito_id
          })
        }

        // Innclusão de Partes
        if (this.obito_updated.registro.partes) {
          this.obito_updated.registro.partes.map(parte => {
            parte.registro_id = this.obito_updated.registro.registro_id
          })
        }

      },

      async getCartorio () {
        this.dadosCartorio = this.$store.getters['auth/getCartorioObj']
      },
      deleteAddress (endereco) {
        this.deleteds.enderecos.push(endereco.endereco_id)
      },
      displayError (type, message) {
        objSwal.error.title = 'Erro ao atualizar registro de óbito'

        if (type === 'HTML') {
          objSwal.error.text = ''
          objSwal.error.html = message
        } else {
          objSwal.error.text = message
          objSwal.error.html = ''
        }

        loader({ text: '', active: false })

        return Swal.fire(objSwal.error)
      },
      invalids (list) {
        if (list.length) {
          list[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: "nearest" })
        }
      },
      verifyParte (parte) {
        this.parte = parte
      },
      verifyErrors ($event = null) {
        this.$root.$emit('bv::hide::modal', `modalMotivoAlteracao`)

        const { pessoa: { nome, cpf }, cpf_sem_inscricao} = this.obito_updated

        if (!nome) return this.displayError('TEXT', 'O nome do registrado é obrigatório.')
        else if (!cpf &&  !cpf_sem_inscricao) return this.displayError('TEXT', 'O CPF do registrado é obrigatório.')
        else {
          setTimeout(() => {
            this.verifyInputs($event)
          },300)
        }
      },
      verifyCorrecoes () {
        const aba = (num) => {
          if (Object.values(this.correcoes).indexOf(num) != -1) return true
        }

        const abas = () => {
          this.errosAbas = Object.values(this.correcoes)
        }

        const campos = (name) => {
          const keys = Object.keys(this.correcoes)

          if (Array.isArray(name)) {
            const equals = name.filter(val => {
              let find = false

              keys.forEach(key => {
                if (key.match(val)) find = true
              })

              return find
            })

            if (equals.length) return true
          } else {
            let find = false

            keys.forEach(key => {
              if (key.match(name)) find = true
            })

            return find
          }
        }

        return { aba, abas, campos }
      },
      deleteError (errors) {
        errors.forEach(error => {
          delete this.correcoes[error]
          this.correcoes = {...this.correcoes}

          this.verifyCorrecoes().abas()
        })
      },
      controlEvent () {
        const addEvent = () => {
          setTimeout(() => {
            const abas = document.querySelectorAll('.nav-link')
            const btnSubmit = document.querySelector('#btn-submit-registro')
            const btnCancel = document.querySelector('#btn-cancel-registro')

            if (abas.length) {
              abas.forEach(aba => {
                aba.onkeydown = nextAba
              })

              abas[0].focus()
            }

            if (btnSubmit) {
              btnSubmit.onkeydown = firstAba
            }

            if (btnCancel) {
              btnCancel.onkeydown = firstAba
            }
          }, 400)
        }

        const nextAba = (event) => {
          if (event.key != 'Tab') return

          const abas = document.querySelectorAll('.nav-link')
          const checkbox = document.querySelector('#pessoaDescon')

          const abasArr = Array.from(abas)

          const index = abasArr.findIndex(aba => aba.id == event.target.id)

          if (index != -1 && index != abasArr.length - 1) {
            setTimeout(() => {
              abas[index + 1].focus()
              abas[index + 1].scrollIntoView({ block: 'center', inline: "nearest" })
            })
          } else if (index != -1 && index == abasArr.length - 1) {
            setTimeout(() => {
              checkbox.focus()
              checkbox.scrollIntoView({ block: 'center', inline: "nearest" })
            })
          }
        }

        const firstAba = (event) => {
          if (event.key != 'Tab') return

          const abas = document.querySelectorAll('.nav-link')
          const btnSubmit = document.querySelector('#btn-submit-registro')

          if (abas) {
            if (event.target.id == 'btn-cancel-registro' && (btnSubmit && btnSubmit.disabled) || event.target.id == 'btn-submit-registro') {
              setTimeout(() => {
                abas[0].focus()
              }, 100)
            }
          }
        }

        return { addEvent, nextAba, firstAba }
      },
      showErrorList (errors) {
        const textSwal = `<ul>${errors.map(res => {
          return `<li>${res}</li>`
        })}</ul>`

        const html = textSwal.replace(/\,/g,'')

        return this.displayError('HTML', html)
      },
      bloquearRegistro (status) {
        this.save({
          codigo: status ? 30 : 10,
          dataAverb: null
        })
      }
    }
  }
</script>

<style lang="scss">
  @import '../../scss/_utilities/_exports';
  @import '../../scss/_components/resumos';
  .headerEditObito{
    position: relative;
    right: 40px;
  }

  .EditarObito {
    & .nav-link {
      border: 1px solid $sinoreg-blue;
      color: $color-black;
      font-size: pxToRem(15);
      border-top-left-radius:0;
      border-top-right-radius:0;

      &_error {
        color: #8B0000;
        font-size: pxToRem(15);
        fill: #8B0000;
      }
    }

    & .nav-link:hover {
      border: 1px solid #696969;
      color: $color-black;
    }

    &--tab-active {
      background-color: $sinoreg-blue !important;
      border: 1px solid $sinoreg-blue !important;
      color: white !important;
      fill: white !important;

      &_error {
        background-color: #8B0000 !important;
        border: 1px solid #8B0000 !important;
        color: white !important;
        fill: white !important;
      }
    }

    &-border ul.nav {
      border-bottom: 3px solid $sinoreg-blue !important;
    }

    &-border ul.nav > li > a,
    &-border ul.nav > li > a:hover {
      border-bottom: 0 solid $sinoreg-blue;
      border-right: 1px solid white;
      border-left: 1px solid white;
      border-top: 1px solid white;
    }

    .btn-danger {
      background-color: #8B0000;
      border-color: #8B0000
    }

    .btn-primary {
      background-color: #086AAE;
      border-color: #086AAE
    }

    .btn-outline-secondary > svg {
      fill: #086AAE
    }

    .btn-outline-secondary:hover > svg {
      fill: white
    }

    .btn-outline-secondary:hover {
      background-color: #086AAE;
      border-color: #086AAE
    }
  }

  .icon-error {
    width: 22px;
    height: 22px;
    margin: 0;
    padding: 0;
  }
</style>
